var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "中文名称",
                            prop: "nameCn",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写中文名称" },
                            model: {
                              value: _vm.inputForm.nameCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "nameCn", $$v)
                              },
                              expression: "inputForm.nameCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "关联用户套餐id",
                            prop: "projectSetsId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写关联用户套餐id" },
                            model: {
                              value: _vm.inputForm.projectSetsId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "projectSetsId", $$v)
                              },
                              expression: "inputForm.projectSetsId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "项目版本id",
                            prop: "projectVersionId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写项目版本id" },
                            model: {
                              value: _vm.inputForm.projectVersionId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "projectVersionId", $$v)
                              },
                              expression: "inputForm.projectVersionId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "套餐空间id",
                            prop: "projectPositionId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写套餐空间id" },
                            model: {
                              value: _vm.inputForm.projectPositionId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.inputForm,
                                  "projectPositionId",
                                  $$v
                                )
                              },
                              expression: "inputForm.projectPositionId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "楼层id",
                            prop: "storeyId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写楼层id" },
                            model: {
                              value: _vm.inputForm.storeyId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "storeyId", $$v)
                              },
                              expression: "inputForm.storeyId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "空间id", prop: "roomId", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写空间id" },
                            model: {
                              value: _vm.inputForm.roomId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "roomId", $$v)
                              },
                              expression: "inputForm.roomId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "位置id",
                            prop: "positionId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写位置id" },
                            model: {
                              value: _vm.inputForm.positionId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "positionId", $$v)
                              },
                              expression: "inputForm.positionId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "项目id",
                            prop: "projectId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写项目id" },
                            model: {
                              value: _vm.inputForm.projectId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "projectId", $$v)
                              },
                              expression: "inputForm.projectId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "面积/数量", prop: "num", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写面积/数量" },
                            model: {
                              value: _vm.inputForm.num,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "num", $$v)
                              },
                              expression: "inputForm.num",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单价", prop: "price", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写单价" },
                            model: {
                              value: _vm.inputForm.price,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "price", $$v)
                              },
                              expression: "inputForm.price",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "项目总价",
                            prop: "totalPrice",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写项目总价" },
                            model: {
                              value: _vm.inputForm.totalPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "totalPrice", $$v)
                              },
                              expression: "inputForm.totalPrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单位", prop: "unitId", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写单位" },
                            model: {
                              value: _vm.inputForm.unitId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "unitId", $$v)
                              },
                              expression: "inputForm.unitId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "描述",
                            prop: "description",
                            rules: [
                              {
                                required: true,
                                message: "描述不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写描述" },
                            model: {
                              value: _vm.inputForm.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "description", $$v)
                              },
                              expression: "inputForm.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "关联项目组id",
                            prop: "linkProjectId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写关联项目组id" },
                            model: {
                              value: _vm.inputForm.linkProjectId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "linkProjectId", $$v)
                              },
                              expression: "inputForm.linkProjectId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "材料方案id",
                            prop: "makeupId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写材料方案id" },
                            model: {
                              value: _vm.inputForm.makeupId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "makeupId", $$v)
                              },
                              expression: "inputForm.makeupId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }